import {Component, ContentChild, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {IResizedColumn, ITable} from '@common/models/table';
import {Observable, takeWhile} from 'rxjs';
import {IColumnDefinition} from '@common/models/column-definition';
import {TableFacadeService} from '@feature/_app_modules/shared/table/services/table-facade.service';
import {EntityKey} from '@pma-entity/pma-entity-types';
import {ListWidgetTableComponent} from '@common/list-widget-table/list-widget-table.component';
import {TableRow, TableRowEvent} from "@layout/lister/tableRow";

/**
 * Standard "Entity" based lister.
 *
 */
@Component({
    selector: 'mojo-lister',
    templateUrl: './lister.component.html',
    standalone: false
})
export class ListerComponent implements OnInit {
  isAlive = true;
  loading$: Observable<boolean>;

  @ContentChild('rowTemplate', {static: true}) rowTemplateRef: TemplateRef<any>;
  @ViewChild(ListWidgetTableComponent) listWidget: ListWidgetTableComponent;
  table: Observable<ITable>;
  availableColumns: Observable<IColumnDefinition[]>;

  /**
   * The name of the entity Type to be displayed in the list (e.g 'Manager', 'Client' etc.)
   */
  @Input() entityName: string;

  /**
   * The EntityKey of the current owner entity if there is one. If specified the data set would be 'All entities of type *entityName* that relate to *ownerEntityKey*
   */
  @Input() ownerEntityKey: EntityKey | undefined;

  @Input() getRowHref: (row) => string;

  /**
   * The event handler for onRowSelect
   */
  @Output() onRowSelect = new EventEmitter();

  constructor(
    private readonly tableFacadeService: TableFacadeService,
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.ownerEntityKey.currentValue !== changes.ownerEntityKey.previousValue) {
      this.loadTableData();
    }
  }

  loadTableData(): void {
    this.tableFacadeService.loadTableData(this.entityName, this.ownerEntityKey, undefined, false);
    this.tableFacadeService.loadAvailableColumns(this.entityName);
  }

  ngOnInit(): void {

    this.table = this.tableFacadeService
      .getTable(this.entityName)
      .pipe(takeWhile(() => this.isAlive));

    this.loading$ = this.tableFacadeService
      .getLoading(this.entityName)
      .pipe(takeWhile(() => this.isAlive));

    this.availableColumns = this.tableFacadeService
      .getAvailableColumns(this.entityName)
      .pipe(takeWhile(() => this.isAlive));
  }

  selectedColumnsChanged(selectedColumns: IColumnDefinition[]): void {
    this.tableFacadeService.setSelectedColumns(
      this.entityName,
      selectedColumns,
      this.ownerEntityKey
    );
  }

  columnsReordered(orderedColumns: string[]): void {
    this.tableFacadeService.setColumnOrder(this.entityName, orderedColumns, this.ownerEntityKey);
  }

  columnsResized(resizedColumn: IResizedColumn): void {
    this.tableFacadeService.setColumnSize(this.entityName, resizedColumn, this.ownerEntityKey);
  }

  resetColumns(): void {
    this.tableFacadeService.resetColumns(this.entityName, this.ownerEntityKey);
  }

  rowSelected(event : TableRowEvent): void {
    this.onRowSelect.emit(event.data);
  }

  triggerRowSelected(event, data: TableRow): void {
    event.preventDefault();
    this.onRowSelect.emit(data);
  }
}





